

import { 
    AccountSchema, MessageSchema, AuthSchema, 
    ResourceSchema, ResourceType, FilterType, 
    CredentialSchema, ResourceBookingSchema, AgreementSubmissionSchema, 
    EnvironmentOptions, FeedPostSchema, MembershipSchema, CommunityAgreementSchema, 
    FocusGroupFormData, FocusGroupSessionSchema, FocusGroupSessionResponseSchema, 
    MyBusinessSchema, CurrentRequirementsSchema, IdpAccountRequestSchema 
} from "../data/types";
import { objectToFormData } from '../utils/helpers'

import config from '../config';
import axios from "axios";
import { CommunitySchema } from "../data/types";
// import { v4 as uuidv4 } from 'uuid';

// Generate unique alphanumeric ID without dashes or special characters
const generateAlphanumericId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

const new_api_host = config.apiUrl

const secretKey = process.env.REACT_APP_SECRET_KEY ? process.env.REACT_APP_SECRET_KEY : ""

const apiKey = process.env.REACT_APP_API_KEY ? process.env.REACT_APP_API_KEY : ""



const axiosInstance = axios.create({
    baseURL: new_api_host,
    timeout: 50000,
    headers: {
        "Content-Type": "application/json",
        accept: "application/json",
    }
})

// Adding API access keys to headers
axiosInstance.defaults.headers.common['HOMECOOK-SECRET-KEY'] = secretKey
axiosInstance.defaults.headers.common['HOMECOOK-API-KEY'] = apiKey



axiosInstance.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;

      if (error.response && error.response.status === 401 && error.response.statusText === "Unauthorized") {
          const refresh_token = localStorage.getItem('refresh_token');

          return axiosInstance
              .post('/kitchens/user/auth', {refresh: refresh_token})
              .then((response) => {

                  let data = (response.data && response.data.body) ? response.data.body : response.data

                  localStorage.setItem('access_token', data.login_token);
                  localStorage.setItem('refresh_token', data.refresh_token);

                  axiosInstance.defaults.headers['Authorization'] = data.login_token
                  originalRequest.headers['Authorization'] = data.login_token

                  return axiosInstance(originalRequest);
              })
              .catch(err => {
                  console.log(err)
              });
      }
      return Promise.reject(error);
  }
)


export const getAllCommunities = async () => {
    let data: CommunitySchema[] | null
    let resourceApiUrl = `/community`
    let response = await axiosInstance.get(resourceApiUrl)
    if (response){
        data = (response.data && response.data.body) ? response.data.body : response.data    
        return data
    }
    return []
}

const getCommunityByID = async (communityId: string) => {
    let data: CommunitySchema | null
    if (communityId) {
        let communityApiUrl = `/community/${communityId}`
        let response = await axiosInstance.get(communityApiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}



const getAllResources = async (resourceType?: ResourceType, communityId?: string, filter?: FilterType) => {
    let data: ResourceSchema[] | null
    let resourceApiUrl = `/resource`

    resourceApiUrl = resourceType ? `${resourceApiUrl}?resource_type=${resourceType}` : resourceApiUrl
    resourceApiUrl = communityId ? `${resourceApiUrl}${resourceType ? '&' : '?'}community_id=${communityId}` : resourceApiUrl    

    let response = await axiosInstance.get(resourceApiUrl)
    if (response){
        data = (response.data && response.data.body) ? response.data.body : response.data
        return data
    }
    return null
}

// const filterResourcesByType = async () => {
//     let data: CommunitySchema | null
//     let new_user_api_url = `/kitchens/community`
//     let response = await axiosInstance.get(new_user_api_url)
//     if (response){
//         data = (response.data && response.data.body) ? response.data.body : response.data
//         return data
//     }
//     return null
// }

const getResourceByID = async (resourceId: string) => {
    let data: ResourceSchema | null
    if (
        resourceId &&
        (
            (typeof resourceId === 'string' && resourceId.length === 24 && /^[a-fA-F0-9]{24}$/.test(resourceId)) ||
            (typeof resourceId === 'string' && resourceId.length === 12)
        )
    ){
        let resourceApiUrl = `/resource/${resourceId}`
        let response = await axiosInstance.get(resourceApiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}


const searchResources = async (q: string) => {
    let data: ResourceSchema[] | null
    let searchOption = q ? `?q=${q}` : ""
    let new_user_api_url = `/kitchens/community${searchOption}`
    let response = await axiosInstance.get(new_user_api_url)
    if (response){
        data = (response.data && response.data.body) ? response.data.body : response.data
        return data
    }
    return null
}



const initiateAuth = async (user: AuthSchema) => {
    let data: any
    let new_user_api_url = `/auth`
    if (user && user?.email){
        user.web_env = process.env.REACT_APP_NODE_ENV as EnvironmentOptions
        localStorage.removeItem('login_token');
        var response = await axiosInstance.post(new_user_api_url, user)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            if (data && data?.login_token){
                localStorage.setItem('login_token', data.login_token)
                // localStorage.setItem('refresh_token', data.refresh_token)
            }
            return data
        }
    }
    return null
}

export const confirmNewIDPAuthUser = async (user: IdpAccountRequestSchema) => {
    let data: any
    let new_user_api_url = `/auth/new`
    if (user && user?.uid){
        var response = await axiosInstance.post(new_user_api_url, user)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            // console.log("confirmNewIDPAuthUser response", data)
            return data
        }
    }
    return null
}



const getAuthUser = async ({token_uid}: AuthSchema) => {
    let data: AccountSchema | null
    let new_user_api_url = `/auth/${token_uid}`

    if (token_uid){
        // let response = await axiosInstance.post(new_user_api_url, {token_uid})
        let response = await axiosInstance.get(new_user_api_url)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}

const getUserDetails = async (uid: string) => {
    let data: AccountSchema | null
    let new_user_api_url = `/auth/${uid}/user`

    var accessToken: any = localStorage.getItem('accessToken')
    axiosInstance.defaults.headers.common['accessToken'] = accessToken
    
    var refreshToken: any = localStorage.getItem('refreshToken')
    axiosInstance.defaults.headers.common['refreshToken'] = refreshToken

    if (uid){
        let response = await axiosInstance.get(new_user_api_url)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}


// Fetch All Message Threads
const getAllMessages = async (uid: string, communityId: string) => {
    // console.log(communityId);
    let data: MessageSchema[]
    
    if (uid){
        communityId = communityId ? communityId : `resource_pantry`
        const apiUrl = `/community/${communityId}/messages/${uid}`
        let response = await axiosInstance.get(apiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return []
}

const sendMessageToUser = async (uid: string, communityId: string, content: string) => {
    let data: MessageSchema | null
    communityId = communityId ? communityId : `resource_pantry`
    let apiUrl = `/community/${communityId}/messages/${uid}?from_member=true`

    // console.log("sendMessageToUser", uid, communityId, content)
    // console.log("apiUrl", apiUrl)
  
    if (content){
        let response = await axiosInstance.post(apiUrl, {content})
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}



const updateUserDetails = async (uid: string, userUpdates: AccountSchema) => {
    let new_user_api_url = `/auth/${uid}/user`

    var accessToken: any = localStorage.getItem('accessToken')
    axiosInstance.defaults.headers.common['accessToken'] = accessToken
    
    var refreshToken: any = localStorage.getItem('refreshToken')
    axiosInstance.defaults.headers.common['refreshToken'] = refreshToken

    const userUpdateForm  = objectToFormData(userUpdates)

    if (uid){
        let response = await axiosInstance.patch(new_user_api_url, userUpdateForm, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        if (response){
            const data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}


export const addSavedResource = async (uid: string, resourceId: string) => {
    let data: ResourceSchema[] | null
    if (uid && resourceId){
        let api_url = `/user/${uid}/resource/${resourceId}`
        let response = await axiosInstance.post(api_url)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}

export const removeSavedResource = async (uid: string, resourceId: string) => {
    let data: ResourceSchema[] | null
    if (uid && resourceId){
        let api_url = `/user/${uid}/resource/${resourceId}`
        let response = await axiosInstance.delete(api_url)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}


const verifyUserOTP = async (otp_code: string, username: string) => {
    let data: AccountSchema | null
    let new_user_api_url = `/community/auth/verify`
    // console.log("otp_code, phone", otp_code, username)
  
    if (otp_code){
        let response = await axiosInstance.post(new_user_api_url, {otp_code, username})
        // console.log('response token_username', response)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}



const generateAIResponse = async (uid: string, prompt: string) => { 
    let data: MessageSchema | null
    // let ai_api_url = `/kitchens/ai/text?prompt=${prompt}`
    const communityId = "resource_pantry"
    const api_url = `/community/${communityId}/messages/${uid}/ai?from_member=true`

    if (prompt){
        let response = await axiosInstance.post(api_url, {content: prompt})
        // console.log('response token_username', response)
        if (response){
            // console.log("generateAIResponse response", response)
            data = (response.data && response.data.body) ? response.data.body : response.data
            // console.log("generateAIResponse data", data)
            return data
        }
    }
    return null
}

export const fetchPaymentHistory = async (uid: string) => {
    // console.log("fetchPaymentHistory uid: ", uid)
    if (uid){
        let fetch_api_url = `/community/account/${uid}/payments`
        let response = await axiosInstance.get(fetch_api_url)
        return response.data
    }
}

export const fetchPaymentMethods = async (uid: string) => {
    try {
    //   console.log("fetchPaymentMethods uid: ", uid)
      if (uid){
      let fetchApiUrl = `/community/account/${uid}/paymethods`
      let response = await axiosInstance.get(fetchApiUrl)
        if (response && response.data){
            let data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
      }
    }
    catch (err) {
      console.log(err)
    }
    return []
}

export const addPaymentSetupIntent = async (uid: string, communityId?: string) => {
    if (uid){
        let fetch_api_url = `/community/setupintent/${uid}`
        let response: any = null
        try {
            if (communityId){
                response = await axiosInstance.post(fetch_api_url, {community_id: communityId})
            } else {
                // Send empty JSON object to satisfy Flask's Content-Type requirement
                response = await axiosInstance.post(fetch_api_url, {})
            }
            
            if (response && response.data){
                console.log("create success");
                let data = (response.data && response.data.body) ? response.data.body : response.data
                return data
            }
        } catch (err) {
            console.log(err);
            throw err; // Re-throw to allow error handling upstream
        }
    }
    return null
}


export const deletePaymentMethod = async (paymentMethodId: string) => {
    if (paymentMethodId){
        let fetch_api_url = `/community/paymethods/${paymentMethodId}`
        try {
            var accessToken: any = localStorage.getItem('accessToken')
            axiosInstance.defaults.headers.common['accessToken'] = accessToken
            
            var refreshToken: any = localStorage.getItem('refreshToken')
            axiosInstance.defaults.headers.common['refreshToken'] = refreshToken

            let response = await axiosInstance.delete(fetch_api_url)
            if (response) {
                console.log("create success");
                return response.data
            }
        } catch (err) {
            console.log(err);
            return null
        }
    }
}


const addMembershipCredentials = async (uid: string, communityId: string, cred: CredentialSchema) => {
    if (communityId && uid && cred){
      let fetch_api_url = `/community/${communityId}/documents/${uid}/verify/new`
      var credForm  = objectToFormData(cred)
      try {
        let response = await axiosInstance.post(fetch_api_url, credForm, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        if (response && response.status === 201) {
          console.log("create success");
          return response.data
        }
      } catch (err) {
        console.log(err);
        return null
      }
    }
  }


  const fetchMemberCredentials = async (uid: string, communityId?: string) => {
    let data: CredentialSchema[] = []
    communityId = communityId ? communityId : `resource_pantry`
    try {
      if (communityId){
      let fetch_api_url = `/community/${communityId}/documents/${uid}`
      let response = await axiosInstance.get(fetch_api_url)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
      }
    }
    catch (err) {
      console.log(err)
    }
    return data
  }


// Fetch Resource Bookings
export const getResourceBookings = async (communityId: string, resourceId: string) => {
    // TO DO: added security check
    let data: ResourceBookingSchema[]
    if (resourceId){
        const apiUrl =`/community/${communityId}/resource/${resourceId}/bookings`
        const response = await axiosInstance.get(apiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return []
}

export const getUserResourceBookingByUid = async (communityId: string, resourceId: string, uid: string) => {
    let data: ResourceBookingSchema
    if (communityId && resourceId && uid){
        // const apiUrl =`/community/${communityId}/resource/${resourceId}/bookings/${uid}`
        const apiUrl =`/community/${communityId}/resource/${resourceId}/bookings?uid=${encodeURIComponent(uid)}`
        // const apiUrl =`/community/${communityId}/resource/${resourceId}/bookings?uid=${uid}`
        const response = await axiosInstance.get(apiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return {} as ResourceBookingSchema
}


  // Fetch Resource Bookings by User
export const getUserResourceBookings = async (uid: string) => {
    let data: MessageSchema[]
    if (uid){
        const apiUrl =`/user/${uid}/bookings`
        const response = await axiosInstance.get(apiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return []
}

export const updateResourceBooking = async (community_id: string, booking_id: string, bookingUpdate: ResourceBookingSchema) => {
    console.log("updateResourceBooking", community_id, booking_id, bookingUpdate)
    if (community_id && booking_id){
        let bookingApiUrl =`/community/${community_id}/bookings/${booking_id}`
        let response = await axiosInstance.patch(bookingApiUrl, bookingUpdate)
        console.log("response", response)
        if (response){
            return response.data
        }
    }
    return null
}

export const cancelResourceBooking = async (community_id: string, resource_id: string, booking_id: string,) => {
    if (community_id && booking_id){
        let bookingApiUrl =`/community/${community_id}/bookings/${booking_id}`
        let response = await axiosInstance.delete(bookingApiUrl)
        return response.data
    }
    return null
}

// CREATE NEW RESOURCE BOOKING
export const createBooking = async (uid: string, new_booking: ResourceBookingSchema) => {
    const { resource_id } = new_booking
    // console.log(new_booking);
    if (uid && resource_id){
        let booking_api_url =`/user/${uid}/resource/${resource_id}/booking`
        try {
            let response = await axiosInstance.post(booking_api_url, new_booking)
            if (response && response.status === 201) {
                console.log("create booking success");
                return response.data
            }
        } catch (err) {
            console.error(err);
            return null
        }
    }
    return null
}

// type KitchenIdParameter = {
//     communityId: string
//     id: string;
// }
  


// Get existing feed posts
const getFeedPosts = async () => {
    let data: FeedPostSchema[] = []
    const communityId = `resource_pantry`
    let fetch_api_url = `/community/${communityId}/feed`
    let response = await axiosInstance.get(fetch_api_url)
    if (response){
        data = (response.data && response.data.body) ? response.data.body : response.data
        return data
    }
    return null
}

// Create new feed post
const newFeedPost = async (uid: string, newPost: FeedPostSchema) => {
    const {content, resource_type} = newPost
    if (uid && content && resource_type) {
        const newPostForm  = objectToFormData(newPost)
        const feedPostApi =`/user/${uid}/posts`
        const response = await axiosInstance.post(feedPostApi, newPostForm)
        if (response){
            return response.data
        }
    }
    return null
}

/** Get member (community) agreement; returns object with presigned url for the .docx file. */
export const getMemberAgreement = async (communityId: string): Promise<CommunityAgreementSchema | null> => {
    if (!communityId) return null;
    const apiUrl = `/community/${communityId}/agreements`;
    try {
      const response = await axiosInstance.get(apiUrl);
      if (response?.data) {
        const data = (response.data?.body != null) ? response.data.body : response.data;
        return data as CommunityAgreementSchema;
      }
    } catch (err) {
      console.error("getMemberAgreement error:", err);
    }
    return null;
}

export const submitMemberAgreement = async (uid: string, communityId: string, memberInfo: AgreementSubmissionSchema) => {
    var data: MembershipSchema | null = null
    if (uid && communityId && memberInfo){
        const apiUrl = `user/${uid}/community/${communityId}/agreements`;
        const memberInfoForm = objectToFormData(memberInfo)
        const response = await axiosInstance.post(apiUrl, memberInfoForm, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return data;
}

export const getMemberRequirementsStatus = async (uid: string) => {
    let data: {[key: string]: CurrentRequirementsSchema[]} | null
    let apiUrl = `/user/${uid}/requirements`
    if (uid){
        let response = await axiosInstance.get(apiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}


// FETCH ACCOUNT MEMBERSHIPs
export const getAccountMemberships = async (uid: string) => {
    let data: MembershipSchema[] | null
    let apiUrl = `/community/account/${uid}/memberships`
    if (uid){
        let response = await axiosInstance.get(apiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}


// FETCH MEMBERSHIP
export const getMembership = async (communityId: string, uid: string) => {
    let data: MembershipSchema | null
    let membershipApiUrl = `/community/${communityId}/members/${uid}`
    if (communityId && uid){
        let response = await axiosInstance.get(membershipApiUrl)
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}


export const addCommunityMember = async (memberUid: string, communityId: string, membership: MembershipSchema) => {
    if (communityId){
      let membershipApiUrl = `/community/${communityId}/members/${memberUid}`;
      try {
        let response = await axiosInstance.post(membershipApiUrl, membership);
        if (response && response.status === 201) {
          console.log("create success");
          return response.data
        }
      } catch (err) {
        console.log(err);
        return null
      }
    }
}


export const updateCommunityMembership = async (communityId: string, uid: string, membership: MembershipSchema) => {
    if (communityId && uid){
      let membershipApiUrl = `/community/${communityId}/members/${uid}`;
      try {
        let response = await axiosInstance.patch(membershipApiUrl, membership);
        if (response && (response.status === 201 || response.status === 200)) {
          console.log("create success");
          return response.data
        }
      } catch (err) {
        console.log(err);
        return null
      }
    }
}


const signOut = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('login_token');
}
const getMembershipPlans = async (communityId: string) => {
    if (communityId){
      let fetch_api_url = `/community/${communityId}/plans`;
  
      try{
        let response = await axiosInstance.get(fetch_api_url);
        if (response) {
          let data = response.data;
          return data;
        }
        return []
      }catch(err){
        console.log(err);
      }
    }
}


const getResourceOptions = async (communityId: string, resource_id:string) => {
    if (communityId){
      let fetch_api_url = `/community/${communityId}/resource/${resource_id}`;
  
      try{
        let response = await axiosInstance.get(fetch_api_url);
        if (response) {
          let data = response.data;
          return data;
        }
        return []
      }catch(err){
        console.error(err);
      }
    }
}


export const getBusinessDetails = async (id: string) => {
    let data: MyBusinessSchema | null
    let apiUrl = `/businesses/${id}`;
    if (id){
        const response = await axiosInstance.get(apiUrl);
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    } 
    // catch (err) {
    //     console.error('Error fetching business details:', err);
    // }
    return null
}

export const getAllBusinesses = async (uid: string) => {
    let data: MyBusinessSchema[] | null
    axiosInstance.defaults.headers.common['accessToken'] = localStorage.getItem('accessToken')
    axiosInstance.defaults.headers.common['refreshToken'] = localStorage.getItem('refreshToken')
    if (uid){
        const response = await axiosInstance.get(`/businesses/${uid}`);
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    } 
    return []
}


export const submitBusinessDetailsForm = async (uid: string, formData: MyBusinessSchema) => {
    let data: MyBusinessSchema | null
    axiosInstance.defaults.headers.common['accessToken'] = localStorage.getItem('accessToken')
    axiosInstance.defaults.headers.common['refreshToken'] = localStorage.getItem('refreshToken')
    if (uid){
        const response = await axiosInstance.post(`/businesses/${uid}`, formData);
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}


export const deleteBusinessDetails = async (username: string, businessId: string) => {
    let data: boolean
    if (username && businessId){
        let apiUrl = `/businesses/${username}/${businessId}`;
        const response = await axiosInstance.delete(apiUrl);
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return false
}


export const submitFocusGroupForm = async (formData: FocusGroupFormData, communityId?: string) => {
    let data: FocusGroupFormData | null
    let apiUrl = communityId 
    ? `/focus-group/${communityId}`
    : '/focus-group';
  
    if (formData){
        const response = await axiosInstance.post(apiUrl, formData);
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    }
    return null
}

export const getFocusGroupData = async (uid: string, communityId: string) => {
    let data: FocusGroupFormData | null
    let apiUrl = (communityId && communityId !== 'dreamers') 
    ? `/focus-group/${uid}/${communityId}`
    : `/focus-group/${uid}`;
  
    try {
        const response = await axiosInstance.get(apiUrl);
        if (response){
            data = (response.data && response.data.body) ? response.data.body : response.data
            return data
        }
    } catch (err) {
        console.error('Error fetching focus group data:', err);
    }
    return null
}

export const getPastSessionResponse = async (uid: string, sessionId: string) => {
    let data: FocusGroupSessionResponseSchema = {} as FocusGroupSessionResponseSchema
    let apiUrl = `/focus-group-session/${sessionId}/username/${uid}`;
    const response = await axiosInstance.get(apiUrl);
    if (response){  
        data = (response.data && response.data.body) ? response.data.body : response.data
        return data
    }
    return data
}



export const submitFocusGroupSessionResponse = async (uid: string, sessionId: string, sessionResponseData: FocusGroupSessionResponseSchema) => {
    if (!uid) {
        uid = generateAlphanumericId();
        console.log("uid", uid, typeof uid)
        sessionResponseData.is_anonymous = true;
    } else {
        sessionResponseData.is_anonymous = false;
    }
    let apiUrl = `/focus-group-session/${sessionId}/username/${uid}`;

    // console.log('apiUrl', apiUrl)
    // console.log('submit', sessionResponseData)
    
    let data: FocusGroupSessionResponseSchema | null
    const response = await axiosInstance.post(apiUrl, sessionResponseData);
    if (response){
        data = (response.data && response.data.body) ? response.data.body : response.data
        console.log('response data', data)
        return data
    }
    return null
}


export const getFocusGroupSessions = async () => {
    let data: FocusGroupSessionSchema[] = []
    // let apiUrl = communityId ? `/focus-group/${communityId}/sessions` : `/focus-group/sessions`;
    let apiUrl = `/focus-group/sessions`;
    const response = await axiosInstance.get(apiUrl);
    if (response){
      data = (response.data && response.data.body) ? response.data.body : response.data
      return data
    }
    return data
}
  
export { 
    initiateAuth, getAuthUser, getUserDetails, updateUserDetails, verifyUserOTP, signOut, 
    getResourceOptions,
    // updateUserData, 
    getCommunityByID, 
    getResourceByID, getAllResources,  searchResources, generateAIResponse,
    // fetchPaymentMethods, addPaymentSetupIntent, addPayIntent,
    // filterResourcesByType
    getAllMessages, sendMessageToUser,
    addMembershipCredentials, 
    fetchMemberCredentials,
    getFeedPosts,
    newFeedPost,
    //  getMemberReviews,
    // createMembership, fetchMemberships, getMembership, updateCommunityMembership, addCommunityMember,
    getMembershipPlans,
    //  createBooking, updateBookingData, fetchMemberBookings, fetchBookingByID, getCommunityBookings
}
